import * as types from '@/store/types';

export default {
  [types.LIST_FAVORITES](state, { favorites }) {
    state.favorites = favorites;
    state.meta = favorites.meta;
  },
  [types.LIST_RECIPROCAL](state, { reciprocal }) {
    state.reciprocal = reciprocal;
    state.meta = reciprocal.meta;
  },
  [types.LIST_SEEN](state, { seen }) {
    state.seen = seen;
  },
  [types.SEEN_PROFILES](state, { seenProfile }) {
    state.seenProfile = seenProfile;
    state.meta = seenProfile.meta;
  }
};
